export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/angle-right.3dea1007.svg","height":28,"width":13};